<template>
  <div>
    <div class="page-integrations__description has-text-centered">
      {{ app.subtitle }}
    </div>
    <div class="buttons">
      <sc-tooltip 
        class="tooltip"
        :label="app.status === 'MANUALLY_INSTALLED' && schemaBasedVersion === 'v2' ? 
        'Você já possui essa transportadora instalada! Veja em Minhas Transportadoras' : ''"
        multilined>
        <sc-button
          v-if="app.status === 'UNINSTALLED' || 
          app.status === 'MANUALLY_INSTALLED' && schemaBasedVersion !== 'v2'"
          class="is-fullwidth"
          theme="primary"
          text="Instalar"
          :disabled="loading"
          @click="() => schemaBasedVersion === 'v2' ? handleStepClick(app) : handleInstallButton(app)"
        />

        <sc-button
          v-else
          class="is-fullwidth"
          theme="success"
          icon="check-circle"
          text="Instalado"
        />
      </sc-tooltip>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from "vuex";

import { Storage } from '@intelipost-js/secure-providers';

import { ScButton, ScDialog, ScToast, ScTooltip } from "@intelipost-js/secure-components";

const { mapState, mapActions, mapMutations } = createNamespacedHelpers(
  "integrations/integrationsHome"
);

export default {
  name: "iplink-app-card-body",

  props: {
    app: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      schemaBasedVersion: {
       version: ''
      },
    };
  },

   computed: {
    ...mapState([
      "loading",
      "appList",
      "selectedApp",
    ]),
  },

  methods: {
    ...mapMutations([
      "selectApp",
    ]),

    ...mapActions([
      "saveIntegrationConfigs",
      "getAppList",
      "showConfigModalAction",
      "selectAppAction",
    ]),

    handleInstallButton(app) {
      if (this.hasSchemaBased(app)) {
        this.selectAppAction(app)
        this.showConfigModalAction(true)
      } else {
        ScDialog.confirm({
          title: "Confirmação de instalação",
          message: `Você tem certeza que deseja instalar o aplicativo <b>${app.name}</b>?`,
          type: "is-info",
          hasIcon: true,
          icon: "check-circle",
          onConfirm: () => this.installAppWhenSchemaBasedIsNull(app),
        });
      }
    },
    handleStepClick(app) {
     this.$router.push({ name: 'integrations-app-v2', params: { id: app.id } });
    },

    handleStepEditClick(app) {
      this.$router.push({ name: 'integrations-app-edit', params: { id: app.id } });
    },

    hasSchemaBased(app) {
      return app.schemaBased !== null;
    },

    installAppWhenSchemaBasedIsNull({ id }) {
      this.saveIntegrationConfigs(id).then(({ ok, message }) => {
        if (ok) {
          this.getAppList();
          return ScToast.success("Aplicativo habilitado com sucesso");
        }
        return ScToast.open({message, duration: 20000, type: 'is-danger'});
      });
    },

  },

  created() {
    if (this.app.schemaBased) {
      this.schemaBasedVersion = JSON.parse(this.app.schemaBased).version;
    }
  },

  components: {
    ScButton,
    ScDialog,
    ScToast,
    ScTooltip,
  },
};
</script>

<style lang='scss'>
@import "~@intelipost-js/secure-ui/src/scss/variables";

.page-integrations {
  .sc-card {
    .card-image {
      .image {
        padding-top: 60%;
      }
    }

    .card-menu-button {
      border: none;
      background-color: white;
      margin: 1rem 0 0 0;
    }

    .report-problem-form {
      display: flex;
      margin-bottom: 2rem;

      .report-problem-button {
        margin-top: 2rem;
      }
    }

    img {
      object-fit: scale-down;
      width: 80%;
      margin: auto;
    }
    .tooltip {
      width: 100%;
    }
    .is-warning {
      background-color: #ffe683;
      border-color: #ffdd57;
    }
  }
}

</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/components/app-list/app-card/body-card/BodyCard.vue